const cleanCompanyName = (company) => typeof company === 'string' ? company.trim().replace(/\s+/g, ' ') : '';

export const normalizeCompanyName = (company) => cleanCompanyName(company).toLocaleLowerCase('es');

export const getCompanyParticipation = (records) => {
  const companies = new Map();
  records.forEach(record => {
    const name = cleanCompanyName(record.company);
    const key = normalizeCompanyName(name);
    if (!key || key === '-') return;
    const company = companies.get(key);
    if (company) company.count += 1;
    else companies.set(key, { name, count: 1 });
  });
  return [...companies.values()];
};

export const getCompanyNames = (records) => getCompanyParticipation(records)
  .map(company => company.name)
  .sort((a, b) => a.localeCompare(b, 'es'));

export const resolveCompanyName = (value, companies) => companies
  .find(company => normalizeCompanyName(company) === normalizeCompanyName(value)) || cleanCompanyName(value);
